export const environment = {
  adminPanel: {url: 'https://c2bdevadmin.production.am', crmOrigin: 'https://c2bdev.production.am'},
  baseApi: 'https://c2bapidev.production.am/api/v1/frontend/',
  baseApiExternal: 'https://c2bapidev.production.am/api/v1/external/',
  baseApiContent: 'https://c2bapidev.production.am/api/v1/content/',
  production: false
};
